import { createSelector } from 'reselect';

const RESOURCE_TYPE_STICKER = 'sticker';
const RESOURCE_TYPE_BATEMPLATE = 'before_after_template';

const RESOURCE_COMPARATOR = (r1, r2) => {
  const typeDiff = r1.type.localeCompare(r2.type);
  if (typeDiff !== 0) {
    return typeDiff;
  }

  const orderDiff = r1.order - r2.order;
  if (orderDiff !== 0) {
    return orderDiff;
  }

  const nameDiff = r1.display_name.localeCompare(r2.display_name);
  return nameDiff;
};

const remoteResourcesSelector = (state) => state.remoteResources;

const remoteResourcesArray = createSelector(
  [remoteResourcesSelector],
  (resources) => {
    const resourceArray = Object.values(resources);
    return resourceArray.sort(RESOURCE_COMPARATOR);
  },
);

const editorStickerKeyURLs = createSelector(
  [remoteResourcesArray],
  (resources) =>
    resources
      .filter((resource) => resource.type === RESOURCE_TYPE_STICKER)
      .map((resource) => {
        const uriData = resource.uris[0];
        return {
          key: resource.identifier,
          src: uriData.uri,
        };
      }),
);

const beforeAfterResources = createSelector(
  [remoteResourcesArray],
  (resources) =>
    resources
      .filter((resource) => resource.type === RESOURCE_TYPE_BATEMPLATE)
      .map((resource) => {
        let imageIcon = null;
        let imageMask = null;
        let imageOverlay = null;

        resource.uris.forEach((uri) => {
          if (uri.type === 'icon') {
            imageIcon = uri.uri;
          } else if (uri.type === 'imageMask') {
            imageMask = uri.uri;
          } else if (uri.type === 'imageOverlay') {
            imageOverlay = uri.uri;
          }
        });

        return {
          templatePOJO: resource.data.templatePOJO,
          imageIcon,
          imageMask,
          imageOverlay,
        };
      }),
);

export { editorStickerKeyURLs, beforeAfterResources };
